<template>
  <div class="quiz-log-container">
    <div class="left-box">
      <div class="go-back-btn" v-if="!isMe" @click="goBack">
        <i class="go-back-icon" />{{ getDict(231) }}
      </div>
      <div class="user-info">
        <span class="user-icon"><img :src="userInfo.icon || undefined" /></span>
        <div class="name">{{ userInfo.name }}</div>
        <!-- <div class="gold"><i class="icon icon-gold-2" />总资产：{{userInfo.gold}}</div> -->
      </div>
      <div class="quiz-info">
        <div><!-- 占位 --></div>
        <div class="gold-info">
          <div class="text">
            <i class="icon icon-gold-2" />{{ getDict(220) /*总资产*/ }}
          </div>
          <div class="num red-black-text">{{ userInfo.gold }}</div>
          <div class="rank linear-gradient">
            <i class="icon-data-anly" />{{ getRankText(userInfo.gold_rank) }}
          </div>
        </div>
        <div class="middle-line linear-gradient"></div>
        <div class="rate-info-box">
          <div class="rate-info-item">
            <div class="rate-num">
              <div class="num red-black-text">
                {{ (userInfo.recycle_rate * 100 || 0).toFixed(0) }}%
              </div>
              <div class="text">{{ getDict(222) /*回収率*/ }}</div>
            </div>
            <div class="rate-rank linear-gradient">
              <i class="icon-data-anly" />{{
                getRankText(userInfo.recycle_rate_rank)
              }}
            </div>
          </div>

          <div class="rate-info-item">
            <div class="rate-num">
              <div class="num red-black-text">
                {{ (userInfo.hit_rate * 100 || 0).toFixed(0) }}%
              </div>
              <div class="text">{{ getDict(223) /*命中率*/ }}</div>
            </div>
            <div class="rate-rank linear-gradient">
              <i class="icon-data-anly" />{{
                getRankText(userInfo.hit_rate_rank)
              }}
            </div>
          </div>
        </div>
        <div><!-- 占位 --></div>
      </div>
    </div>
    <div class="right-box">
      <div class="type-title">
        <div
          class="type-item"
          :class="logTypeKey == typeItem.type ? 'active' : ''"
          @click="logTypeKey = typeItem.type"
          v-for="(typeItem, index) in logTypeList"
          :key="index"
        >
          {{ typeItem.name }}
        </div>
      </div>
      <div class="log-list" ref="logList" @scroll="onScrollList">
        <div
          class="log-item"
          :class="['wait-log', 'true-log', 'false-log'][logItem.state]"
          v-for="(logItem, index) in logTypeListCalc"
          :key="index"
        >
          <div class="log-title">
            <span class="question">{{ logItem.qname }}</span>
            <span class="text-icon"></span>
          </div>
          <div class="quiz-log-info">
            <div class="my-quiz">
              <span
                >{{ (logItem.ts * 1000) | formatDate("MM月DD日 HH:mm:ss ")
                }}{{
                  getDict(224, [
                    logItem.op_name,
                    logItem.gold,
                  ]) /*【选项】投入X张逐梦券*/
                }}</span
              >
            </div>
            <div class="answer-info">
              <span v-if="logItem.state != 0"
                >{{
                  getDict(230, [
                    logItem.answer_name,
                    logItem.state == 1
                      ? "+" + logItem.win_gold
                      : "-" + logItem.gold,
                    logItem.answer_rate > 9999
                      ? "9999+"
                      : (+logItem.answer_rate || 0).toFixed(2),
                  ])
                }}<!-- 最终结果：【{{ logItem.answer_name }}】，竞猜币{{
                  logItem.state == 1 ? logItem.win_gold : -logItem.gold
                }}（实时赔率{{ logItem.answer_rate }}） --></span
              >
              <span v-if="logItem.state == 0">{{
                getDict(225) /*等待开奖...*/
              }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getDict,
  axios,
  getPageLevelMixin,
  webSocket,
} from "../../../../common";
import { mapState, mapGetters } from "vuex";

export default {
  name: "quizLogPage",
  mixins: [getPageLevelMixin],
  props: {
    uid: {},
  },
  data() {
    return {
      pageLevel: 1,

      pageLimit: 20,
      devReplyTime: 0,

      userInfo: {
        // uid:123,
        // name:'user',
        // icon:'https://nie.res.netease.com/r/pic/20200603/187bb5a3-5d56-4577-b2f7-552f83c10846.png',
        // gold:100,
        // gold_rank:10,
        // win_count:12,
        // quiz_count:20,
        // hit_rate:0.3,
        // hit_rate_rank:20,
        // recycle_rate:0.4,
        // recycle_rate_rank:30,
      },

      logTypeKey: "0",
      logTypeList: [
        {
          type: "0",
          name: getDict(226) /*'全部竞猜'*/,
          list: [],
          nextCursor: 0,
          loading: false,
        },
        {
          type: "1",
          name: getDict(227) /*'待开奖'*/,
          list: [],
          nextCursor: 0,
          loading: false,
        },
        {
          type: "2",
          name: getDict(228) /*'已开奖'*/,
          list: [],
          nextCursor: 0,
          loading: false,
        },
      ],

      quizLogList: [
        // ...Array(33).fill({}).map((item,index)=>{
        //   item = {
        //     qname:'q' + index,
        //     op_name:'select' + index,
        //     answer_name: 'true' + index,
        //     answer_rate:1.2,
        //     state:index % 3,
        //     gold:20,
        //     win_gold:30,
        //     ts:1615359596,
        //   }
        //   return item;
        // })
      ],

      listStatus: {
        height: 0,
        boxHeight: 0,
        top: 0,
      },

      exchangeingGift: null,
    };
  },
  computed: {
    // ...mapState(['userData']),
    ...mapGetters(["gambleUserInfo"]),
    curLogObj() {
      let logObj = this.logTypeList.find((logType) => {
        return logType.type == this.logTypeKey;
      });
      return logObj;
    },
    logTypeListCalc() {
      return this.curLogObj ? this.curLogObj.list : [];
    },
    listLenght() {
      return this.logTypeListCalc.length;
    },
    isMe() {
      return this.uid === undefined || this.uid == this.gambleUserInfo.uid;
    },
  },
  watch: {
    userInfo() {
      this.logTypeList.map((obj) => {
        this.getLogList(obj);
      });
    },
    listLenght(newData, oldData) {
      if (newData < oldData) {
        this.$refs.logList.scrollTop = 0;
      }
      this.$nextTick(() => {
        this.resetListStatus(true);
      });
    },
  },
  methods: {
    getRankText(rank = 0) {
      return rank && rank < 1000 ? getDict(221, [rank]) /*第${1}名*/ : "999+"; //getDict(229); /*榜外*/
    },
    goBack() {
      this.$emit("goBack");
    },
    getDict,
    async getUserInfo() {
      if (this.isMe) {
        this.userInfo = this.gambleUserInfo;
        return;
      }
      this.userInfo = {};
      let res = await serverApi.get("user", {
        uid: this.uid,
      });
      if (res.code == 200) {
        if (res.data.icon) {
          res.data.icon = res.data.icon.replace(/^http:/, "");
        }
        this.userInfo = res.data;
      }
    },
    async getLogList(obj) {
      if (!this.userInfo || !this.userInfo.uid) {
        return;
      }
      if (obj.nextCursor == -1 || obj.loading) {
        return;
      }
      let pageSize = this.pageLimit;
      //调试用
      if (this.devReplyTime) {
        pageSize = Math.ceil(pageSize / this.devReplyTime);
      }
      obj.loading = true;
      let res = await serverApi.get("quiz_log", {
        uid: this.userInfo.uid,
        state: obj.type,
        cursor: obj.nextCursor,
        limit: pageSize,
      });
      obj.loading = false;
      if (res.code == 200) {
        if (res.data.quiz_logs) {
          let addList = res.data.quiz_logs;

          //调试用
          if (this.devReplyTime) {
            let list1 = [];
            for (let item of addList) {
              for (let index = 0; index < this.devReplyTime; index++) {
                list1.push({
                  ...item,
                });
              }
            }
            addList = list1;
          }
          obj.list = obj.list.concat(addList);
        }
        obj.nextCursor = +res.data.next_cursor || 0;
      }
    },
    onScrollList() {
      this.resetListStatus();
      if (
        this.listStatus.top + 3 * this.listStatus.boxHeight >
        this.listStatus.height
      ) {
        if (this.curLogObj) {
          this.getLogList(this.curLogObj);
        }
      }
    },
    resetListStatus(widthChange = false) {
      if (!this.$refs.logList) {
        return;
      }
      if (widthChange) {
        this.listStatus.boxHeight = this.$refs.logList.clientHeight;
        this.listStatus.height = this.$refs.logList.scrollHeight;
      }
      this.listStatus.top = this.$refs.logList.scrollTop;
    },
  },
  components: {},
  mounted() {
    this.$nextTick(() => {
      this.resetListStatus(true);
    });

    this.$busOn("setRemUnit", () => {
      //$busOn
      this.resetListStatus(true);
    });
  },
  created() {
    this.getUserInfo();
  },
};
</script>

<style lang="scss" scoped>
.red-black-text {
  position: relative;
  background-image: -webkit-linear-gradient(-104deg, #5c1413, #e04445);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.quiz-log-container {
  // display: flex;
  flex: 1;
  height: 0;
  margin-bottom: 0.3rem;
  display: flex;
  align-items: stretch;

  .left-box {
    width: 3.19rem;
    display: flex;
    flex-direction: column;
    position: relative;
    display: flex;
    align-items: center;

    .go-back-btn {
      position: absolute;
      top: 0;
      left: 0;
      height: 0.42rem;
      line-height: 0.42rem;
      padding: 0 0.1rem;

      background-color: rgba(#d2d8dd, 0.2);
      font-size: 0.24rem;
      color: #fff;
      .go-back-icon {
        display: inline-block;
        position: relative;
        $height: 0.24rem;
        $width: $height * (29/24);
        width: $width;
        height: $height;
        background: url(./imgs/go-back.png) no-repeat;
        background-size: 100% 100%;
        margin-right: 0.2em;
      }
    }
    .user-info {
      width: 100%;
      height: 1.85rem;
      padding: 0.2rem 0;

      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      background: url(./imgs/user-info-top-bg.png) no-repeat;
      background-size: 100% auto;
      background-position: bottom;
      background-color: rgba(#0b3564, 0.4);
      color: #fff;
      text-align: center;

      .user-icon {
        $size: 0.66rem;
        width: $size;
        height: $size;
        border-radius: 50%;
        border: 2px rgba(#094485, 0.7) solid;
        img {
          border: 1px rgba(#ffeb77, 0.9) solid;
          width: 100%;
          height: 100%;
          border-radius: 50%;
        }
      }
      .name {
        font-size: 0.24rem;
        margin-top: 0.1rem;
      }
      .gold {
        font-size: 0.2rem;
        display: flex;
        align-items: center;
        .icon {
          font-size: 1.5em;
        }
      }
    }
    .quiz-info {
      width: 100%;
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      align-items: center;
      padding-bottom: 0.5rem;

      background: url(./imgs/user-info-bottom-bg.png) no-repeat;
      background-size: cover;
      background-position: bottom;

      .icon-data-anly {
        display: inline-block;
        $height: 1em;
        height: $height;
        width: $height * (18 / 19);
        margin-right: 0.2em;
        background: url(./imgs/icon-anly.png) no-repeat;
        background-size: cover;
      }

      .linear-gradient {
        background-image: -webkit-linear-gradient(
          left,
          rgba(#fff2b7, 0),
          rgba(#fff2b7, 1),
          rgba(#fff2b7, 0)
        );
      }

      .gold-info {
        display: flex;
        flex-direction: column;
        align-items: center;
        .text {
          display: flex;
          align-items: center;

          font-size: 0.22rem;
          font-weight: 600;
          color: #7b6437;
          .icon {
            font-size: 1.1em;
          }
        }
        .num {
          margin: 0.1rem 0;
          text-align: center;
          font-size: 0.4rem;
          font-weight: 600;
          color: #fff;
        }
        .rank {
          width: 1.42rem;
          height: 0.3rem;
          line-height: 0.3rem;

          font-size: 0.2rem;
          text-align: center;
        }
      }
      .middle-line {
        width: 3.19rem;
        height: 0.01rem;
      }
      .rate-info-box {
        display: flex;
        justify-content: space-around;
        padding: 0 0.2rem;
        width: 100%;

        .rate-info-item {
          .rate-num {
            margin: auto;
            width: 0.91rem;
            height: 0.91rem;
            background: url(./imgs/quiz-time-bg.png) no-repeat;
            background-size: cover;
            text-align: center;
            .num {
              color: #fff;
              font-size: 0.28rem;
            }
            .text {
              color: #5b3605;
              font-size: 0.2rem;
            }
          }
          .rate-rank {
            margin: auto;
            margin-top: 0.05rem;
            width: 1.02rem;
            // width: 1.1rem;//榜外的日文需要的长度。
            height: 0.3rem;
            line-height: 0.3rem;

            font-size: 0.2rem;
            text-align: center;
          }
        }
      }
    }
  }

  .right-box {
    display: flex;
    flex: 1;
    flex-direction: column;
    margin-left: 0.2rem;
    border: 0.01rem solid rgba(255, 255, 255, 0.2);
    $border-radius: 0.1rem;
    border-top-left-radius: $border-radius;
    border-top-right-radius: $border-radius;
    overflow: hidden;

    background-color: rgba(255, 255, 255, 0.1);

    .type-title {
      $type-title-height: 0.57rem;
      height: $type-title-height;
      background-color: rgba(0, 0, 0, 0.2);
      display: flex;
      flex-shrink: 0;
      width: 100%;

      .type-item {
        $padding-bottom: 0.06rem;
        width: 33.3%;
        text-align: center;
        height: $type-title-height;
        line-height: $type-title-height - $padding-bottom;
        font-size: 0.26rem;
        color: #fff;
        text-shadow: 0 -0.01rem 0.06rem rgba(0, 0, 0, 0.38);

        &.active {
          border-bottom: $padding-bottom solid #ffbb1c;
          background-image: -webkit-linear-gradient(
            bottom,
            rgba(255, 187, 28, 0.3),
            rgba(255, 187, 28, 0)
          );
        }
      }
    }

    .log-list {
      // min-height: 0;
      height: 0; //解决部分设备商品列表超框问题
      flex: 1; //解决部分设备商品列表超框问题
      flex-shrink: 1;
      overflow: auto;

      .log-item {
        margin-bottom: 0.15rem;
        margin-top: 0.15rem;
        // &:last-child{
        //   margin-bottom:0;
        // }
        //    'wait-log','true-log','false-log'
        $title-linear-gradient-start: 30%;
        $title-linear-gradient-start-operate: 1;
        $title-linear-gradient-end-operate: 0;
        .text-icon {
          flex-shrink: 0;
        }
        &.wait-log {
          .log-title {
            background-image: -webkit-linear-gradient(
              left,
              rgba(#596bb9, $title-linear-gradient-start-operate) #{$title-linear-gradient-start},
              rgba(#596bb9, $title-linear-gradient-end-operate)
            );
            .text-icon {
              background-image: url(./imgs/wait-text.png);
            }
          }
          .quiz-log-info {
            .answer-info {
              color: #a5b6ff;
            }
          }
        }
        &.true-log {
          .log-title {
            background-image: -webkit-linear-gradient(
              left,
              rgba(#f4bc65, $title-linear-gradient-start-operate) #{$title-linear-gradient-start},
              rgba(#f4bc65, $title-linear-gradient-end-operate)
            );
            .text-icon {
              background-image: url(./imgs/true-text.png);
            }
          }
          .quiz-log-info {
            .answer-info {
              color: #f4bc65;
            }
          }
        }
        &.false-log {
          .log-title {
            background-image: -webkit-linear-gradient(
              left,
              rgba(#777777, $title-linear-gradient-start-operate) #{$title-linear-gradient-start},
              rgba(#777777, $title-linear-gradient-end-operate)
            );
            .text-icon {
              background-image: url(./imgs/false-text.png);
            }
          }
          .quiz-log-info {
            .answer-info {
              color: #cfcfcf;
            }
          }
        }

        .log-title {
          // height: 0.61rem;

          display: flex;
          align-items: center;
          justify-content: space-between;
          .question {
            display: inline-block;
            border-left: 0.03rem solid #fff;
            $height: 0.34rem;
            margin: 0.15rem 0;
            // height: $height;
            line-height: $height;
            padding-left: 1em;
            font-size: 0.26rem;
            font-weight: 600;
            color: #fff;
          }
          .text-icon {
            $height: 0.64rem;
            width: $height * (164 / 64);
            height: $height;
            background-size: 100% 100%;
          }
        }
        .quiz-log-info {
          height: 1rem;
          background-image: -webkit-linear-gradient(
            left,
            rgba(#204268, 0.8) 50%,
            rgba(#204268, 0.6) 70%,
            rgba(#204268, 0)
          );
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          padding: 0.1rem 0.2rem;
          color: #fff;
          font-size: 0.2rem;
        }
      }
    }
  }
}
</style>
